import { List, FormControl, InputBase, MenuItem, Select, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import getActionMensagemLida from 'src/actions/chats/getActionMensagemLida';

import getActionAceitarChat from 'src/actions/chats/getActionAceitarChat';
import getActionChatByChatId from 'src/actions/chats/getActionChatByChatId';
import {
  getChatInfoByChatId,
  getChatsAtendimento,
  getChatsFinalizados,
  getMensagensWhatsapp,
  getMensagensWhatsappDb,
  removeChatFromList,
  setChatInfo,
  setPushChatList,
  updateChatList,
  getCountsChats
} from 'src/redux/slices/chat';
import { useDispatch } from 'src/redux/store';
import { PATH_CHAT } from 'src/routes/paths';
import useAuth from 'src/hooks/useAuth';
import ChatAtendimentoItem from '../ChatsListItem/ChatAtendimentoItem';
import { useState } from 'react';
import { Button } from 'src/@/components/ui/button';
import Iconify from 'src/components/Iconify';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Checkbox } from 'src/@/components/ui/checkbox';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'src/@/components/ui/accordion';
import { verifyRules } from 'src/utils/functions';
import v2_actionFinalizarMultiplosChats from 'src/actions/v2/chats/v2_actionFinalizarMultiplosChats';
import { useSnackbar } from 'notistack';




// ----------------------------------------------------------------------

ChatConversationListFinalizado.propTypes = {
  chats: PropTypes.array,
  onSelectContact: PropTypes.func
};

const CompactInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    fontSize: 12,
    padding: '4px 8px',
    color: '#374151',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      borderColor: '#9ca3af',
    },
    '&:focus': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 1px #3b82f6',
    },
    '&::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
  },
}));

export default function ChatConversationListFinalizado({ 
  chats, 
  isOpenSidebar, 
  cliente,
  listaTagsReduce,
  listaCanaisReduce,
  tagsSelecionadas,
  canaisSelecionados,
  chatsNaoLidos,
  changeTags,
  changeCanais,
  changeChatsNaoLidos,
  limparFiltro,
  isFiltered
}) {
  const navigate = useNavigate();
  const { user } = useAuth()
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation('chat');

  const [visibleItems, setVisibleItems] = useState(10);
  const [loadingLimparChats, setLoadingLimparChats] = useState(false);
  const [openModalConfimacao, setOpenModalConfimacao] = useState(false);

  const loadMoreItems = () => {
    setVisibleItems((prev) => prev + 10);
  };

  // Função para aplicar filtros
  const applySortFilter = ({
    tableData,
    tagsSelecionadas,
    canaisSelecionados,
    chatsNaoLidos
  }) => {
    // Se não há filtros selecionados, retorna os dados originais
    if ((!tagsSelecionadas || tagsSelecionadas.length === 0) && 
        (!canaisSelecionados || canaisSelecionados.length === 0) && 
        (!chatsNaoLidos || chatsNaoLidos.length === 0)) {
      return tableData || [];
    }

    let filteredData = [];

    function mapStatus(status) {
      // Supports both pt-BR and en label values from sidebar filter
      const statusMap = {
        "Chats não lidos": "sim",
        "Chats lidos": "nao",
        "Unread chats": "sim",
        "Read chats": "nao"
      };
      return statusMap[status] || status;
    }

    const chatsNaoLidoMapped = (chatsNaoLidos || []).map(mapStatus);
    let currentData = [...(tableData || [])];

    if (tagsSelecionadas && tagsSelecionadas.length > 0) {
      filteredData = [];
      currentData.forEach((item) => {
        if (item.tags_ids && Array.isArray(item.tags_ids)) {
          const filteredTags = item.tags_ids.filter((tag) => tagsSelecionadas.includes(tag.nome));
          if (filteredTags.length > 0) {
            filteredData.push(item);
          }
        }
      });
      currentData = filteredData;
    }

    if (canaisSelecionados && canaisSelecionados.length > 0) {
      filteredData = [];
      currentData.forEach((item) => {
        if (canaisSelecionados.includes(item.nome_canal)) {
          filteredData.push(item);
        }
      });
      currentData = filteredData;
    }

    if (chatsNaoLidos && chatsNaoLidos.length > 0) {
      filteredData = [];
      currentData.forEach((item) => {
        if (chatsNaoLidoMapped.includes(item.novaMensagem)) {
          filteredData.push(item);
        }
      });
      currentData = filteredData;
    }

    return currentData;
  };

  const dataFiltered = applySortFilter({
    tableData: chats || [],
    tagsSelecionadas: tagsSelecionadas || [],
    canaisSelecionados: canaisSelecionados || [],
    chatsNaoLidos: chatsNaoLidos || []
  });

  async function limparChats() {
    try {
      let data = {
        usuarioId: user.id,
        status: 'Finalizado',
        clienteId: cliente._id,
      };
      setLoadingLimparChats(true);
      const result = await v2_actionFinalizarMultiplosChats(data);
      if (!result.data.error) {
        dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, true));
        dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
      }
      setLoadingLimparChats(false);
      enqueueSnackbar(t('sidebar.chatsFinalized'), { variant: 'success' });
    } catch (error) {
      setLoadingLimparChats(false);
      console.log(error);
      enqueueSnackbar(t('sidebar.clearChatsError'), { variant: 'error' });
    }
  }

  const handlePegarChat = async (chatId) => {
    try {
      const response = await getActionChatByChatId({ chatId: chatId });
      if (response.data.statusRoom !== 'Atendendo') {
        dispatch(removeChatFromList({ chatId: chatId, status: 'Finalizado' }));
        getActionAceitarChat({ chatId: chatId, usuarioId: user.id });
        let dataToUpdade = {
          _id: chatId,
          scope: {
            novaMensagem: 'sim',
            statusRoom: 'Atendendo',
            direciona_usuarios: [user.id],
            direciona_setores: [],
            lastUpdate: new Date()
          }
        };
        dispatch(updateChatList(dataToUpdade)); // Atualiza a lista de chats
      }



      // dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
      // dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, false));

    } catch (error) {
      console.log(error)
    }
  }


  const handleSelectConversation = async (chat) => {
    if (!chat) return;
  
    const isUserTargeted = chat.direciona_usuarios?.[0] === user.id;
    const isSectorTargeted = chat.direciona_setores?.[0] === user.setorId;
  
    if (isUserTargeted || isSectorTargeted) {
      // Atualiza a lista de chats
      const dataToUpdate = {
        _id: chat._id,
        scope: { novaMensagem: 'nao' },
      };
      dispatch(updateChatList(dataToUpdate));
  
      // Marca mensagens como lidas
      await getActionMensagemLida({ chatId: chat._id });

      let newChat = {
        ...chat,
        novaMensagem: 'nao',
        lastUpdate: new Date()
      }

      setPushChatList(newChat, "Atendendo");
  
      // Busca mensagens do WhatsApp
      dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
  
      // Define ou busca informações do chat
      if (chat) {
        dispatch(setChatInfo(chat));
      } else {
        dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
      }
  
      // Navega para a rota do chat
      navigate(`${PATH_CHAT.chat.root}`);
    }
  };


  return (
    <List>
      {dataFiltered.slice(0, visibleItems).map((result, index) => (
        <ChatAtendimentoItem
          key={result._id}
          onSelectConversation={() => handleSelectConversation(result)}
          onAceitarChat={() => handlePegarChat(result._id)}
          isOpenSidebar={isOpenSidebar}
          chat={result}
        />
      ))}
      {visibleItems < dataFiltered.length && (
        <Button className="w-full bg-pink-800 hover:bg-violet-600 text-white" onClick={loadMoreItems} fullWidth>
          {t('list.loadMore')}
        </Button>
      )}
    </List>
  );
}
